(function () {
  if (window.__rekalCardProductControlsLoaded) return;
  window.__rekalCardProductControlsLoaded = true;

  function formatPrice(cents, currency) {
    const locale = document.documentElement.lang || 'sv-SE';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency || 'SEK',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 2,
    }).format(cents / 100);
  }

  function quantityValue(input) {
    return Math.max(Number.parseInt(input?.value, 10) || 1, 1);
  }

  function updatePriceItems(container, cents, currency) {
    if (!container || !Number.isFinite(cents)) return;
    const formattedPrice = formatPrice(cents, currency);
    container.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach((item) => {
      item.textContent = formattedPrice;
    });
  }

  function updatePdpQuantityPrice(input) {
    const productInfo = input?.closest('product-info');
    const price = productInfo?.querySelector("[id^='price-'] .price[data-unit-price]");
    if (!price) return;
    updatePriceItems(price, Number(price.dataset.unitPrice) * quantityValue(input), price.dataset.currencyCode);
  }

  window.updateRekalQuantityPrice = updatePdpQuantityPrice;

  function updateControls(select, resetQuantity = true) {
    if (!select) return;
    const form = select.closest('form');
    const controls = select.closest('.card-product-controls');
    const option = select.selectedOptions[0];
    if (!form || !controls || !option) return;

    const variantInput = form.querySelector('.product-variant-id');
    const articleNumberInput = form.querySelector('[data-article-number-property]');
    const quantityInput = form.querySelector('.quantity__input');
    const submitButton = form.querySelector('.card-product-controls__submit');
    const card = controls.closest('.product-card, .predictive-search__product');
    const price = card?.querySelector('[data-card-price]') || controls.closest('.card__information')?.querySelector('[data-card-price]');
    const variantInfo = card?.querySelector('[data-card-variant-info]');
    const allowZero = controls.dataset.allowZeroQuantity === 'true';

    if (variantInput) variantInput.value = option.value;
    if (articleNumberInput) articleNumberInput.value = option.dataset.cardArticleNumber || '';
    if (variantInput) variantInput.disabled = option.dataset.available !== 'true';
    if (submitButton) {
      const available = option.dataset.available === 'true';
      submitButton.disabled = !available;
      const label = available ? submitButton.dataset.addLabel : submitButton.dataset.soldOutLabel;
      const labelElement = submitButton.querySelector('span:not(.loading__spinner)');
      if (labelElement && label) labelElement.textContent = label;
    }
    if (price && option.dataset.priceCents) {
      updatePriceItems(price, Number(option.dataset.priceCents) * quantityValue(quantityInput), controls.dataset.currencyCode);
    }

    if (variantInfo) {
      variantInfo.querySelectorAll('[data-card-variant-info-value]').forEach((element) => {
        const value = option.dataset[`card${element.dataset.cardVariantInfoValue[0].toUpperCase()}${element.dataset.cardVariantInfoValue.slice(1)}`];
        element.textContent = value || '-';
      });
    }

    if (quantityInput) {
      const min = option.dataset.min || '1';
      quantityInput.min = allowZero ? '0' : min;
      quantityInput.step = option.dataset.step || '1';
      quantityInput.dataset.min = min;
      if (option.dataset.max) {
        quantityInput.max = option.dataset.max;
        quantityInput.dataset.max = option.dataset.max;
      } else {
        quantityInput.removeAttribute('max');
        delete quantityInput.dataset.max;
      }
      if (resetQuantity) {
        quantityInput.value = allowZero ? '0' : min;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (allowZero) {
      if (submitButton) submitButton.disabled = option.dataset.available !== 'true' || !(Number(quantityInput?.value) > 0);
      controls.dispatchEvent(new CustomEvent('rekal:card-controls-updated', { bubbles: true }));
    }
  }

  function initVariantDropdown(select) {
    if (select.dataset.cardVariantDropdownInitialized === 'true') return;

    const wrapper = select.closest('.card-product-controls__variant');
    const selectedOption = select.selectedOptions[0];
    if (!wrapper || !selectedOption) return;

    select.dataset.cardVariantDropdownInitialized = 'true';
    select.hidden = true;

    let trigger = wrapper.querySelector('.card-product-controls__variant-trigger');
    if (!trigger) {
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'card-product-controls__variant-trigger select__select';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');

      const label = document.createElement('span');
      label.className = 'card-product-controls__variant-label';
      trigger.append(label);

      const caret = wrapper.querySelector('.icon-caret');
      if (caret) trigger.append(caret);
      wrapper.append(trigger);
    }
    const label = trigger.querySelector('.card-product-controls__variant-label');

    const list = document.createElement('ul');
    list.className = 'card-product-controls__variant-list';
    list.id = `${select.id}-options`;
    list.setAttribute('role', 'listbox');
    trigger.setAttribute('aria-controls', list.id);

    Array.from(select.options).forEach((option, index) => {
      const item = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'card-product-controls__variant-option';
      button.textContent = option.textContent.trim();
      button.dataset.optionIndex = index;
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', String(option.selected));
      button.disabled = option.disabled;
      item.append(button);
      list.append(item);
    });

    function syncSelectedOption() {
      const index = select.selectedIndex;
      const option = select.options[index];
      label.textContent = option ? option.textContent.trim() : '';
      list.querySelectorAll('[role="option"]').forEach((button) => {
        button.setAttribute('aria-selected', String(Number(button.dataset.optionIndex) === index));
      });
    }

    function closeList() {
      wrapper.classList.remove('card-product-controls__variant--open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', () => {
      const isOpen = wrapper.classList.toggle('card-product-controls__variant--open');
      trigger.setAttribute('aria-expanded', String(isOpen));
    });

    list.addEventListener('click', (event) => {
      const button = event.target.closest('[data-option-index]');
      if (!button) return;
      select.selectedIndex = Number(button.dataset.optionIndex);
      select.dispatchEvent(new Event('change', { bubbles: true }));
      closeList();
      trigger.focus();
    });

    select.addEventListener('change', syncSelectedOption);
    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) closeList();
    });

    wrapper.append(list);
    syncSelectedOption();
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-card-variant-select]')) updateControls(event.target);
    if (event.target.matches('.card-product-controls .quantity__input')) {
      const controls = event.target.closest('.card-product-controls');
      updateControls(controls?.querySelector('[data-card-variant-select]'), false);
    }
    if (event.target.matches('.product__variant-quantity .quantity__input')) updatePdpQuantityPrice(event.target);
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-allow-zero-quantity] .quantity__input, .predictive-search__purchase .quantity__input')) {
      updateControls(event.target.closest('.card-product-controls').querySelector('[data-card-variant-select]'), false);
    }
  });

  function initVariantDropdowns(root = document) {
    root.querySelectorAll('[data-card-variant-select], [data-pdp-variant-select]').forEach((select) => {
      if (select.closest('[data-allow-zero-quantity]') && select.dataset.cardVariantDropdownInitialized === 'true') return;
      updateControls(select);
      if (select.dataset.nativeSelect !== 'true') initVariantDropdown(select);
    });
  }

  window.initRekalVariantDropdowns = initVariantDropdowns;
  initVariantDropdowns();
})();
